(function () {
  // ====== 只改这里 ======
  var COUPON_CODE = "WELCOME15"; // 15% discount code (must exist in Shopify Discounts)
  var PRODUCT_HANDLE = "omega-3-6-7-9-gummies-for-women";
  var POPUP_DELAY_MS = 1500; // 1.5s
  // =======================

  function $(id) { return document.getElementById(id); }

  function isHomePage() {
    return window.location.pathname === "/" || window.location.pathname === "/index.html";
  }

  function showPopup() {
    var overlay = $("sp-coupon-overlay");
    var modal = $("sp-coupon-modal");
    if (!overlay || !modal) return;
    overlay.style.display = "block";
    modal.style.display = "block";
  }

  function closePopup() {
    $("sp-coupon-overlay")?.style.setProperty("display", "none");
    $("sp-coupon-modal")?.style.setProperty("display", "none");
  }

  function copyCode() {
    var codeEl = $("spCouponText");
    if (codeEl) codeEl.textContent = COUPON_CODE;

    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(COUPON_CODE).then(function () {
        alert("Copied: " + COUPON_CODE);
      }).catch(function () {
        alert("Coupon: " + COUPON_CODE);
      });
    } else {
      alert("Coupon: " + COUPON_CODE);
    }
  }

  // ✅ Apply discount and go to the specific product page
  function goToProductWithDiscount() {
    var redirectPath = "/products/" + PRODUCT_HANDLE;
    var url =
      "/discount/" +
      encodeURIComponent(COUPON_CODE) +
      "?redirect=" +
      encodeURIComponent(redirectPath);

    window.location.href = url;
  }

  function init() {
    // ✅ Only run on homepage
    if (!isHomePage()) return;

    // Fill coupon text
    var codeEl = $("spCouponText");
    if (codeEl) codeEl.textContent = COUPON_CODE;

    // Bind buttons
    $("spCloseBtn")?.addEventListener("click", closePopup);
    $("spNotNowBtn")?.addEventListener("click", closePopup);
    $("sp-coupon-overlay")?.addEventListener("click", closePopup);
    $("spCopyBtn")?.addEventListener("click", copyCode);

    // ✅ IMPORTANT: make the main button go to the product with discount
    $("spShopBtn")?.addEventListener("click", goToProductWithDiscount);

    // Show every time homepage refreshes
    setTimeout(showPopup, POPUP_DELAY_MS);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();